'use strict';

import axios from 'axios';
import moment from 'moment';
import qs from 'qs';

import Api from '@/api/vacancy.js';

export default {
  namespaced: true,
  state() {
    return {
      loading: false,
      loading_update: false,
      loading_remove: false,
      error: null,
      vacancies: [],
      vacancies_list: [],
      list_dropdown: [],
      vacancies_all: [],
      vacancies_selected: [],
      selected_list: [],
      vacancies_total: 0,
      filters_request_time: null,
      sorting: {
        name: null,
        order: 'asc'
      },
      pagination: {
        pageNumber: 1,
        totalPages: 1,
        load_more_pages: 1,
        is_load_more: false,
        limit: 20
      },
      filter: {
        vacancy_ids: [],
        // shops_ids: [], // sportmaster
        // cities_ids: [], // sportmaster
        dates: [],
        creators_ids: [],
        modules_ids: [],
        query_filter: []
      },
      filters_list: {
        filter_vacancies: [],
        filter_temp_dates: [],
        filter_creators: [],
        filter_modules: []
      },
      isExpiredModalShow: false,
      isCreatingModalShow: false
    };
  },

  mutations: {
    SET_LOADING(state, val) {
      state.loading = val;
    },

    SET_LOADING_REMOVE(state, val) {
      state.loading_remove = val;
    },

    SET_LOADING_UPDATE(state, val) {
      state.loading_update = val;
    },

    SET_ERROR(state, val) {
      state.error = val;
    },

    SET_VACANCIES_LIST(state, val) {
      state.vacancies_list = val;
    },

    SET_IS_EXPIRED_MODAL_SHOW(state, val) {
      state.isExpiredModalShow = val;
    },

    SET_IS_CREATING_MODAL_SHOW(state, val) {
      state.isCreatingModalShow = val;
    },

    SET_LIST_DROPDOWN(state, val) {
      let list = val.map(item => {
        return {
          id: item.id,
          name: item.title
        };
      });

      state.list_dropdown = list;
    },

    CLEAR_SELECTED_LIST(state) {
      state.selected_list = [];
    },

    SET_LOAD_MORE(state, val) {
      state.pagination.is_load_more = val;
    },

    SET_FILTER_ITEM(state, data) {
      state.filter[data.key] = data.v;
    },

    RESET_PAGINATION(state) {
      state.pagination = {
        pageNumber: 1,
        totalPages: 1,
        load_more_pages: 1,
        is_load_more: false,
        limit: 20
      };
    },

    SET_PAGINATION(state, params) {
      state.pagination = Object.assign(state.pagination, params);
      if (state.pagination.is_load_more) {
        state.pagination.load_more_pages = Math.ceil(params.count / state.pagination.limit);
      }
    },

    SET_TOTAL_ITEMS(state, val) {
      state.vacancies_total = val;
    },

    SET_SELECTED(state, { id, value }) {
      let vacancy = state.vacancies_list.find(vacancy => vacancy.id === id);

      if (value) {
        state.selected_list.push(vacancy);
      } else {
        state.selected_list = state.selected_list.filter(vacancy => vacancy.id !== id);
      }
    },

    ADD_TO_LIST(state, { data, keys }) {
      keys.forEach(item => {
        let old_ids = state[item].map(i => i.id);
        data.forEach(i => {
          // избегаем дублей
          if (old_ids.indexOf(i.id) === -1) {
            state[item].push(i);
          }
        });
      });
    },

    CHANGE_PAGINATION_COUNT(state, val) {
      state.pagination.limit = val;
      state.pagination.pageNumber = 1;
    },

    SET_FILTERS(state, data) {
      state.filters_list.filter_vacancies = data.filter(i => i.id === 'vacancy')[0].list;
      // state.filters_list.filter_temp_dates = data.filter(i => i.id === 'date_created')[0].list.map(i => i.id);
      state.filters_list.filter_creators = data.filter(i => i.id === 'owner')[0].list;
      state.filters_list.filter_modules = data.filter(i => i.id === 'module')[0].list;
    },

    SET_FILTER(state, val) {
      state.filter = val;
    },

    CLEAR_FILTERS(state) {
      state.filters_list = {
        filter_vacancies: [],
        filter_temp_dates: [],
        filter_creators: [],
        filter_modules: []
      };
      state.filter = {
        vacancy_ids: [],
        // shops_ids: [], // sportmaster
        // cities_ids: [], // sportmaster
        dates: [],
        creators_ids: [],
        modules_ids: [],
        query_filter: []
      };
    },

    FETCH_SUCCESS(state, { data, key }) {
      state[key] = data;
      state.loading = false;
    },

    SET_VACANCIES(state, vacancies) {
      state.vacancies = vacancies;
      state.loading = false;
    },

    FETCH_FAILURE(state, err) {
      state.error = err;
      state.loading = false;
    },

    SET_SORTING(state, data) {
      Object.assign(state.sorting, data);
    },

    ADD_TO_SELECTED(state, model) {
      state.vacancies_selected = [...state.vacancies_selected, model];
    },

    REMOVE_FROM_SELECTED(state, model) {
      state.vacancies_selected = state.vacancies_selected.filter(vacancy => vacancy.id !== model.id);
    },

    SET_FILTERS_REQUEST_TIME(state, val) {
      state.filters_request_time = val;
    },

    CLEAR_SELECTED(state) {
      state.vacancies_selected = [];
    },

    CLEAR_VACANCIES(state) {
      state.vacancies = [];
      state.pagination = Object.assign({}, state.pagination, {
        pageNumber: 1,
        totalPages: 1,
        load_more_pages: 1,
        is_load_more: false
      });
    }
  },

  actions: {
    fetchVacanciesList({ getters, commit, dispatch }, data) {
      commit('SET_LOADING', true);

      let params = getters['getFetchParams'](data, 'vacancies_list');

      return Api.fetchList(params)
        .then(({ data, meta }) => {
          commit('FETCH_SUCCESS', { data, key: 'vacancies_list' });
          commit('SET_PAGINATION', meta);
          commit('SET_TOTAL_ITEMS', meta.total);
        })
        .catch(err => {
          dispatch('global/setError', err, { root: true });
          commit('FETCH_FAILURE', err);
        });
    },

    async fetchVacanciesListDropdown({ state, commit }, data) {
      commit('SET_LOADING', true);

      // let params = getters['getFetchParams'](data, 'list_dropdown');
      let params = {
        filter: {
          id: [],
          user_id: [],
          created_at: {},
          stages: []
        }
      };
      let sorting = state.sorting;
      let pagination = state.pagination;
      let limit = pagination.limit;
      let list_length = null;
      list_length = state.vacancies.length;

      // v3
      if (state.filter.vacancy_ids.length > 0) {
        params.filter.id = state.filter.vacancy_ids;
      }
      if (state.filter.creators_ids.length > 0) {
        params.filter.user_id = state.filter.creators_ids;
      }
      if (state.filter.dates.length > 0) {
        params.filter.created_at = {
          from: state.filter.dates[0],
          to: state.filter.dates[1] ? state.filter.dates[1] : state.filter.dates[0]
        };
      }
      if (state.filter.modules_ids.length > 0) {
        params.filter.stages = state.filter.modules_ids;
      }

      if (data && data.isActive !== undefined) {
        params.filter.active = data.isActive;
      }
      if (sorting.name) {
        params.sort = [];
        params.sort['by'] = sorting.name;
        params.sort['order'] = sorting.order;
      }
      // if (data && data.searchTerm !== undefined) {
      params.filter['title'] = data.searchTerm;
      // }
      if (data && data.permission !== undefined) {
        params.permission = data.permission;
      }
      if (pagination.is_load_more) {
        if (list_length) {
          limit = pagination.pageNumber * list_length + limit;
          params.page = 1;
        } else {
          params.page = pagination.pageNumber + 1;
        }
        params.limit = limit;
      } else {
        params.page = pagination.pageNumber;
        params.limit = pagination.limit;
      }

      return await Api.fetchListDropdown(params)
        .then(({ data, meta }) => {
          commit('SET_LIST_DROPDOWN', data);
          commit('SET_TOTAL_ITEMS', meta.total);
          commit('SET_PAGINATION', meta);
          commit('SET_LOADING', false);
        })
        .catch(err => {
          commit('FETCH_FAILURE', err);
          return Promise.reject(err);
        });
    },

    loadMoreVacancies({ commit, getters }, isActive) {
      commit('SET_LOAD_MORE', true);

      let params = getters['getFetchParams']({ isActive }, null);

      return Api.fetchList(params)
        .then(({ data, meta }) => {
          commit('ADD_TO_LIST', { data, keys: ['vacancies', 'vacancies_list'] });
          commit('SET_PAGINATION', meta);
          commit('SET_LOAD_MORE', false);
        })
        .catch(err => {
          commit('SET_ERROR', err);
          commit('SET_LOADING', false);
          commit('SET_LOAD_MORE', false);
          return Promise.reject(err);
        });
    },

    async fetchVacancies({ state, commit, dispatch }, data) {
      commit('SET_LOADING', true);

      // let params = getters['getFetchParams'](data, 'vacancies');

      let params = {
        filter: {
          id: [],
          user_id: [],
          created_at: {},
          stages: []
        }
      };
      let sorting = state.sorting;
      let pagination = state.pagination;
      let limit = pagination.limit;
      let list_length = null;
      list_length = state.vacancies.length;

      // v3
      if (state.filter.vacancy_ids.length > 0) {
        params.filter.id = state.filter.vacancy_ids;
      }
      if (state.filter.creators_ids.length > 0) {
        params.filter.user_id = state.filter.creators_ids;
      }
      if (state.filter.dates.length > 0) {
        params.filter.created_at = {
          from: state.filter.dates[0],
          to: state.filter.dates[1] ? state.filter.dates[1] : state.filter.dates[0]
        };
      }
      if (state.filter.modules_ids.length > 0) {
        params.filter.stages = state.filter.modules_ids;
      }

      if (data && data.isActive !== undefined) {
        params.filter.active = data.isActive;
      }
      if (sorting.name) {
        params.sort = [];
        params.sort['by'] = sorting.name;
        params.sort['order'] = sorting.order;
      }
      if (data && data.searchTerm !== undefined) {
        params.filter['title'] = data.searchTerm;
      }
      if (data && data.permission !== undefined) {
        params.permission = data.permission;
      }
      if (pagination.is_load_more) {
        if (list_length) {
          limit = pagination.pageNumber * list_length + limit;
          params.page = 1;
        } else {
          params.page = pagination.pageNumber + 1;
        }
        params.limit = limit;
      } else {
        params.page = pagination.pageNumber;
        params.limit = pagination.limit;
      }

      console.log(params);

      return await Api.fetchList(params)
        .then(response => {
          commit('SET_VACANCIES', response.data);
          // commit('FETCH_SUCCESS', { data: response.data, key: 'vacancies' });
          commit('SET_PAGINATION', response.meta);
        })
        .catch(err => {
          dispatch('global/setError', err, { root: true });
          commit('FETCH_FAILURE', err);
        });
      // }
    },

    fetchVacanciesAll({ commit, dispatch, getters }, data) {
      let params = getters['getFetchParams'](data, null);

      return Api.fetchList(params)
        .then(({ data }) => {
          commit('FETCH_SUCCESS', { data, key: 'vacancies_all' });
        })
        .catch(err => {
          dispatch('global/setError', err, { root: true });
          commit('FETCH_FAILURE', err);
        });
    },

    updateVacancies({ dispatch, commit }, val) {
      commit('SET_LOADING_UPDATE', true);

      return axios
        .put('/1.0/vacancies', { vacancies: val })
        .then(() => dispatch('company_new/get_rates', null, { root: true }))
        .then(() => {
          commit('CLEAR_SELECTED_LIST');
          commit('SET_LOADING_UPDATE', false);
        })
        .catch(err => {
          commit('CLEAR_SELECTED_LIST');
          commit('SET_ERROR', err);
          commit('SET_LOADING_UPDATE', false);
          return Promise.reject(err);
        });
    },

    removeVacancies({ commit, dispatch }, data) {
      commit('SET_LOADING_REMOVE', true);
      let { vacancies_delete, force } = data;

      return axios
        .delete(`/1.0/vacancies`, {
          data: { vacancies: vacancies_delete },
          params: { force }
        })
        .then(() => dispatch('company_new/get_rates', null, { root: true }))
        .then(() => {
          commit('CLEAR_SELECTED_LIST');
          commit('SET_LOADING_REMOVE', false);
        })
        .catch(err => {
          commit('CLEAR_SELECTED_LIST');
          commit('SET_ERROR', err);
          commit('SET_LOADING_REMOVE', false);
          return Promise.reject(err);
        });
    },

    loadFiltersVacancies({ commit }, { filter, activeVacancies }) {
      axios
        .get('/1.0/vacancies/filters', {
          params: { filter, is_active: activeVacancies },
          paramsSerializer: params => {
            return qs.stringify(params);
          }
        })
        .then(r => {
          commit('SET_FILTERS', r.data.data);
          commit('SET_FILTERS_REQUEST_TIME', moment());
          return r.data.data;
        });
    },

    setSelectedList({ commit }, { id, value }) {
      commit('SET_SELECTED', { id, value });
    },

    setSelectedState({ commit }, { model, state }) {
      if (state) {
        commit('ADD_TO_SELECTED', model);
      } else {
        commit('REMOVE_FROM_SELECTED', model);
      }
    },

    copyVacancies({ commit, dispatch }, modelIds) {
      commit('SET_LOADING', true);

      return axios
        .post('/1.0/vacancy-copies', { vacancies: modelIds })
        .then(() => dispatch('company_new/get_rates', null, { root: true }))
        .then(() => {
          commit('SET_LOADING', false);
        })
        .catch(err => {
          commit('CLEAR_SELECTED_LIST');
          commit('FETCH_FAILURE', err);
          return Promise.reject(err);
        });
    },

    clearVacancies({ commit }) {
      commit('SET_ERROR', null);
      commit('SET_LOADING', false);
      commit('SET_LOADING_REMOVE', false);
      commit('SET_LOADING_UPDATE', false);
      commit('SET_VACANCIES_LIST', []);
      commit('SET_LIST_DROPDOWN', []);
      commit('CLEAR_SELECTED_LIST');
      commit('SET_SORTING', {
        name: null,
        order: 'asc'
      });
      commit('RESET_PAGINATION');
    },

    clearFiltersVacancies({ commit }) {
      commit('SET_FILTER_ITEM', { key: 'query_filter', v: [] });
      commit('SET_FILTER_ITEM', { key: 'dates', v: [] });
      commit('SET_FILTER_ITEM', { key: 'creators_ids', v: [] });
      commit('SET_FILTER_ITEM', { key: 'modules_ids', v: [] });
      commit('SET_FILTER_ITEM', { key: 'query_filter', v: [] });
      commit('CLEAR_FILTERS');
    }
  },

  getters: {
    getFetchParams: (state, getters) => (data = null, list = null) => {
      let params = {};
      let sorting = state.sorting;
      let pagination = state.pagination;
      let limit = pagination.limit;
      let list_length = null;

      if (list) {
        list_length = state[list].length;
      }
      if (!params.filter) {
        params.filter = [];
      }
      if (getters['getFilterV3'] !== null && data && data.isActive === true) {
        params.filter = getters['getFilterV3'];
      }
      if (data && data.isActive !== undefined) {
        params.filter['active'] = data.isActive;
      }
      if (sorting.name) {
        params.sort = [];
        params.sort['by'] = sorting.name;
        params.sort['order'] = sorting.order;
      }
      if (data && data.searchTerm !== undefined) {
        params.filter['title'] = data.searchTerm;
      }
      if (data && data.permission !== undefined) {
        params.permission = data.permission;
      }
      if (pagination.is_load_more) {
        if (list && list_length) {
          limit = pagination.pageNumber * list_length + limit;
          params.page = 1;
        } else {
          params.page = pagination.pageNumber + 1;
        }
        params.limit = limit;
      } else {
        params.page = pagination.pageNumber;
        params.limit = pagination.limit;
      }
      return params;
    },

    // @TODO: refactor
    getFilterV3(state) {
      let filter_V3 = [];
      if (state.filter.vacancy_ids.length > 0) {
        filter_V3['id'] = state.filter.vacancy_ids;
      }
      if (state.filter.creators_ids.length > 0) {
        filter_V3['user_id'] = state.filter.creators_ids;
      }
      if (state.filter.dates.length > 0) {
        filter_V3['created_at'] = {
          from: state.filter.dates[0],
          to: state.filter.dates[1] ? state.filter.dates[1] : state.filter.dates[0]
        };
      }
      if (state.filter.modules_ids.length > 0) {
        filter_V3['stages'] = state.filter.modules_ids;
      }
      return filter_V3;
    },

    getIsSelected: state => model => state.selected_list.some(vacancy => vacancy.id === model.id),

    getFilterQuery(state) {
      let params = [];

      state.filter.query_filter.forEach(i => {
        let key, id;
        switch (i) {
          case 'vacancy': {
            id = 'vacancy';
            key = 'vacancy_ids';
            break;
          }
          case 'shop': {
            id = 'shop';
            key = 'shops_ids';
            break;
          }
          case 'city': {
            id = 'city';
            key = 'cities_ids';
            break;
          }
          case 'dates': {
            id = 'date_created';
            key = 'dates';
            break;
          }
          case 'creator': {
            id = 'owner';
            key = 'creators_ids';
            break;
          }
          case 'module': {
            id = 'module';
            key = 'modules_ids';
            break;
          }
        }
        if (state.filter[key].length > 0) {
          params.push({
            id: id,
            list: state.filter[key]
          });
        }
      });
      return params;
    },

    getActiveVacancies: state => {
      return state.vacancies.filter(vacancy => vacancy.active);
    },

    getArchivedVacancies: state => {
      return state.vacancies.filter(vacancy => !vacancy.active);
    },

    getVacanciesSelected: state => isActive => {
      return state.vacancies_selected.filter(vacancy => vacancy.active === isActive);
    },

    getIsSelectedVacancies: state => model => {
      return state.vacancies_selected.some(vacancy => vacancy.id === model.id);
    }
  }
};
